import { Component, HostBinding, Input } from '@angular/core';
import * as moment from 'moment-timezone';

import { LOCAL_TZ } from '../../globals';
import { convert, METERS, NAUTICAL_MILES } from '../../util/units';
import { LatLon } from '../../util/geodesy/latlon';
import { getIntercardinalDirection } from '../../util/geodesy/helpers';
import { Taf } from '../models/taf.model';
import { formatTimeRange, LOCAL_TIME_FMT } from '../../util/datetime-utils';
import { Forecast } from '../models/forecast.model';


@Component({
  selector: 'app-taf',
  templateUrl: './taf.component.html',
  styleUrls: ['./taf.component.scss'],
  preserveWhitespaces: true
})
export class TafComponent {
  private _referencePoint: LatLon;
  distance: number|null = null;
  direction: string = null;

  /**
   * TAF to display
   */
  @Input() taf: Taf;

  /**
   * Whether to display the TAF in translated mode
   */
  @Input()
  @HostBinding('class.wx--translated')
  translated = true;

  @HostBinding('class.wx--raw')
  get raw(): boolean {
    return !this.translated;
  }

  /**
   * Reference lat/lon. If provided, the distance and bearing from the reference point will be shown in the header
   * (e.g., "25 nm NW").
   */
  @Input() set referencePoint(point: LatLon) {
    this._referencePoint = point;
    this.distance = null;
    this.direction = null;
    if (point) {
      const result = point.vincentyInverse(this.taf.location);
      if (result && !isNaN(result.distance)) {
        this.distance = convert(result.distance, METERS, NAUTICAL_MILES);
        this.direction = getIntercardinalDirection(result.initialBearing);
      }
    }
  }

  get issueTimeLocal(): string {
    return moment(this.taf.issueTime).tz(LOCAL_TZ).format(LOCAL_TIME_FMT);
  }

  formatForecastRange(forecast: Forecast): string {
    return formatTimeRange(forecast.validFrom, forecast.validTo);
  }

  formatChangeIndicator(forecast: Forecast): string {
    if (!forecast.changeIndicator) {
      return '';
    }
    if (forecast.changeIndicator === 'PROB' && forecast.probability) {
      return forecast.changeIndicator + forecast.probability;
    }
    return forecast.changeIndicator || '';
  }
}
